'use client';

import { Button } from '@nextui-org/react';
import { ServerCrash } from 'lucide-react';
import React from 'react';
import discordLogo from '../icons/discord-icon-svgrepo-com.svg';
import { useNavigate } from 'react-router-dom';

const NotFound404 = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate('/prompts');
  };

  // Function to navigate to Discord
  const goToDiscord = () => {
    navigate('https://discord.gg/XVvuMWdz'); // Replace your_invite_code with your actual invite code
  };

  return (
    <div className='flex flex-col items-center justify-center h-screen bg-white'>
      <ServerCrash size={96} color='red-500' />
      <h1 className='mt-8 text-2xl font-bold text-gray-900'>404 - Page Not Found</h1>
      <p className='mt-2 text-lg text-gray-700'>
        We know we're not perfect, but hey, even Mona Lisa is missing her eyebrows! If you need us, we're just a Discord message away.
      </p>
      <Button fontSize='lg' ghost round auto className='mt-8' onClick={goBack}>
        Go to Main Page
      </Button>
      {/* Discord Link Button */}
      {/* Discord Link Button with Logo */}
      <Button fontSize='lg' ghost round auto className='mt-8 flex items-center' onClick={goToDiscord}>
        <img src={discordLogo} alt='Discord Logo' className='h-6 w-6 mr-2' />
        Ask us anything in the Discord
      </Button>
    </div>
  );
};

export default NotFound404;
